export default {
  messages: {
    content: {
      home: "首頁",
      product: "產品",
      confirm: "是否退出登錄？",
      case: "案例展示",
      conpany: "公司動態",
      service_support: "服務支持",
      helper: "幫助中心",
      about: "關於我們",
      shiledApp: "超級盾(APP版)",
      defenceIp: "高防IP",
      shiledPc: "超級盾(PC版)",
      defenceServer: "高防服務器",
      h5Shield: "超級盾(H5版)",
      shiledWeb: "超級盾(Web版)",
      ec: "電商解決方案",
      chess: "棋牌遊戲解決方案",
      game: "遊戲解決方案",
      more: "查看詳情",
      detail: "查看詳情",
      free: "免費試用",
      buy: "立即購買",
      function: "產品功能",
      introduce:
        "超級盾Web版（分布式Web應用雲防火牆），針對網站、Web遊戲、H5遊戲等領域推出的專業、高性價比的雲安全防禦產品。Web應用主要基於HTTP/HTTPS等通用協議，很容易受到攻擊，超級盾（web版）全面防禦所有類型DDoS/CC攻擊，自動觸發，實時防護，負載均衡，集群防護，加密傳輸，頁面性能優化，提升網站訪問能力，隱藏源站IP，保證系統安全和可用性。",
      necc: "網站防禦DDoS/CC等攻擊必備產品",
      pro: "幫助上千萬家客戶 解決網站流量攻擊問題",
      ge: "個性化定製套餐",
      sati: "滿足不同防護需求,客戶滿意率高達百分百",
      getit: "超級盾（Web版）國內基礎防護套餐（可定製）",
      category: "類別",
      norm: "指標",
      parameter: "參數",
      DDoSbase: "DDoS基礎防護（BGP）",
      DDoSf: "DDoS流量防護（峰值）",
      exc500: "超過500G可定製",
      general: "通用CC防禦（每小時IP）",
      unlimited: "不限",
      customizable: "可定製",
      support: "支持",
      depth: "深度",
      bandwidth: "業務帶寬",
      qps: "QPS峰值",
      supportnum1: "支持一級域名個數",
      supportnum2: "支持二級域名個數",
      normaltra: "正常訪問流量峰值(每小時)",
      attack: "攻擊IP封堵時間",
      limitspeed: "智能限速",
      superpro: "超級防護",
      superprolimit: "超級防護範圍限制",
      bwlist: "黑白名單",
      cussupport: "客戶支持",
      consult: "專有技術顧問",
      attack: "攻擊防護策略代維",
      attacklan: "Web攻擊攔截",
      zeroday: "0Day漏洞虛擬補丁",
      iplist: "IP/UPL黑白名單",
      single: "獨享IP防護",
      superserve: "防護策略優化專家服務",
      addwaf: "增強WAF",
      tamperproof: "網頁防篡改",
      consultpri: "諮詢套餐價格",
      sensitivedata: "敏感數據防泄漏",
      allweb: "全行業網站可接入",
      cantkill: "打不死，防得住，保證業務穩定運行",
      websiteweb: "網站Web防禦接入流程",
      threestep: "簡單三步，防禦無上限",
      pro_ads: "產品優勢",
      framework: "方案架構",
      server: "服務推薦",
      confirm: "是否退出登錄？",
      onlineConsulting: "在線諮詢",
      freeTrial: "免費試用",
      product_function: "產品功能",
      product_advs: "產品優勢",
      product_config: "產品配置",
      compare_advs: "對比優勢",
      customer_group: "客戶群體",
      customers_group: "客戶群體",
      customer_case: "客戶案例",
      node_distribution: "節點分布",
      other_recommendation: "其它服務",
      other_service: "其它服務",
      v_chess: "棋牌",
      v_game: "遊戲",
      e_Commerce: "電商",
      financial: "金融",
      Government_Enterprise: "政企",
      tel: "400-108-9688",
      email: "chaojidun@chaojidun.com",
      hour: "(7*24h)",
      service_hotline: "全國統一服務熱線",
      exclusive_answerer: "專屬小二在線答疑",
      scan_QR_code: "掃一掃",
      attention: "關注公眾號",
      solution_one: "專業定製化解決方案",
      solution_two: "針對各行業業務特性，為您提供一站式安全解決方案",
      correlation: "相關產品",
      consult: "立即諮詢",
      advantage: "優勢特點",
      EC: "電商",
      EC_solution: "電商解決方案",
      EC_text:
        "針對電商行業高並發，垃圾流量，惡意刷單，突發大規模惡意攻擊，漏洞攻擊制定專屬解決方案，助力電商客戶應對各種業務問題，保障電商交易安全進行，電商活動順利完成！",
      EC_advantage_text:
        "高效防DDoS攻擊，CC攻擊，防漏洞，防篡改，防SQL注入，數據指紋驗證，智能DNS，智能緩存，提供7*24小時安全運維保障服務。",
      Game: "遊戲",
      game_solution: "遊戲解決方案",
      game_text:
        "滿足移動端APP、PC端等各種場景安全需求。抵禦大流量攻擊和CC攻擊；智能加速，遊戲不卡不掉線。對APP進行加固，防倒賣遊戲幣、防作弊、防止薅羊毛。海量攻防實戰積累，為遊戲運營打造可信賴的安全解決方案。",
      game_advantage_text:
        "分布式架構，智能路由、弱網加速，遊戲不卡不掉線；無上限防禦DDoS，100%防CC，被攻擊時完全無感，支持移動端APP、PC端遊戲場景，有效防止倒賣遊戲幣、防作弊、防止薅羊毛等行為。",
      Financial: "金融",
      financial_solution: "金融解決方案",
      financial_text:
        "通過從網絡、業務、數據等多個維度為金融客戶在應用、業務、可用等安全領域提供量身定製的個性化安全解決方案，通過立體防護機制抵禦多種惡意攻擊，海量計算、彈性部署解決業務的海量並發，結合資深安全專家服務，助力金融行業做到全面合規、持續發展，保障業務和數據安全。",
      financial_advantage_text:
        "為HTTP／HTTPS業務提供SQL注入、XSS跨站、Webshell上傳、非授權訪問等多種Web服務攻擊防護功能，並提供T級DDoS流量清洗防護以及千萬級異常請求過濾的CC防護。",
      education: "教育行業",
      education_solution: "教育行業解決方案",
      education_text:
        "針對教育信息化發展所面臨的網絡漏洞和數據泄露風險，為教育行業提供移動APP加固、Web防火牆，防止黑客的惡意篡改、代碼植入，抵禦大流量攻擊和CC攻擊，為教育類APP、網站提供合規、安全的解決方案，助力教育信息化的安全發展。",
      education_advantage_text:
        "全方位對移動APP進行加固，防止被劫持、木馬、入侵、篡改，提供SQL注入、XSS跨站、Webshell上傳、非授權訪問等多種Web服務攻擊防護功能。",
      customized: "定製",
      customized_solution: "定製解決方案",
      customized_text:
        "提供1V1專屬安全專家服務，快速響應客戶需求，並制定專有的安全解決方案。",
      customized_advantage_title_one: "事前—風險評估",
      customized_advantage_title_two: "事中—定期巡查",
      customized_advantage_title_three: "事後—應急響應",
      customized_advantage_text_one: "安全技術團隊進行全面安全監測與加固服務。",
      customized_advantage_text_two:
        "安全技術團隊定期協助用戶進行日常監控與巡查。",
      customized_advantage_text_three:
        "安全技術團隊1小時內協助用戶進行應急響應。",
      product_superiority: "產品優勢與實力",
      product_superiority_text: "網站防禦CC/DDoS流量攻擊的必備神器",
      prevent: "防得住",
      prevent_text: "無視DDoS,CC攻擊防禦無上限",
      use: "用得起",
      use_text: "收費標準統一透明，高性價比受信賴",
      play: "玩得好",
      play_text: "SDN實現智能動態加速保障最佳用戶體驗",
      look: "看得見",
      look_text: "自主可視化後台管理網絡狀態一目了然",
      quick: "上得快",
      quick_text: "只需一句話嵌入SDK即可實現完美對接",
      defense_capability: "全網防禦能力",
      hard_defense_capability: "硬防能力",
      cleanout_center: "東南亞清洗中心",
      CC_defense: "CC防禦",
      defense_node: "防禦節點",
      use_client: "應用客戶",
      node_distribution: "節點分布",
      node_distribution_text: "全球無縫對接，BGP線路，自選節點數",
      partner: "合作夥伴"
    },
    help: {
      service_support: "服務支持",
      service_support_text:
        "超級科技為您提供7×24小時的專業服務，以及多樣化的支持服務，滿足您從上雲部署、日常運維到優化升級等的全周期需求。",
      safeguard_title: "7*24小時保障",
      safeguard_text: "全天候管家式服務",
      major_title: "專業技術服務",
      major_text: "在線防禦專家指導",
      cost_performance_title: "極高性價比",
      cost_performance_text: "成本低、收費透明",
      client_service: "客戶服務",
      consultation_service_title: "專業的諮詢規劃服務",
      consultation_service_text:
        "為客戶提供專業的產品和服務介紹，針對客戶的實際應用和需求，量身定製整體解決方案，全程跟蹤項目，為項目的實施提供技術支持。",
      technical_support_title: "1V1技術支持",
      technical_support_text:
        "提供一對一的技術服務。專屬技術經理會在服務期內提供專業的技術支持。更快定位並解決問題，為您提供有針對性技術支持和服務。",
      service_hotline_title: "客戶服務熱線",
      service_hotline_text:
        "提供在線客服服務，包括400電話、在線客服以及郵件等方式，全面保障您的業務正常運轉。",
      help_document: "帮助文档",
      join_up_title: "接入流程",
      join_up_text: "新用戶使用流程指導",
      shiled_app_title: "超級盾SDK",
      shiled_app_text: "超級盾添加源機指南",
      web_firewall_title: "Web防火牆",
      web_firewall_text: "Web防火牆添加源機指南",
      defence_ip_title: "高防服務器IP",
      defence_ip_text: "高防服務器購買指南",
      view_details: "查看詳情",
      FAQ: "常見問題",
      question_one: "註冊超級盾賬戶時收不到驗證碼怎麼辦？",
      answer_one:
        "由於欠費停機、存儲信息已滿、信號網絡延遲等原因沒有及時收到驗證碼，這時請檢查您的手機及話費餘額，保證手機可正常接收短信後，請嘗試重新獲取驗證碼。",
      question_two: "支持哪些語言的服務端SDK？",
      answer_two:
        "目前支持各項服務的Java、PHP、Python、C#、Node.js版本服務端SDK，我們會儘快陸續推出更多語言支持，請您持續關注。",
      question_three: "新賬號進入時沒有選擇專屬客服？",
      answer_three:
        "系統後台會自動分配專屬客服，如果您之前有專門對接經理，直接聯繫對接經理添加即可。",
      question_four: "我可以創建多少個應用？",
      answer_four: "每項服務創建應用沒有上限。",
      question_five: "目前都開放了哪些服務？",
      answer_five:
        "目前APP 盾，Web 盾，高防服務器 這三項技術您可以直接在控制台中使用。",
      question_six: "流量數據顯示不準確？",
      answer_six:
        "相關數據是根據客戶綁定軟件實時反應，如覺得數據有差異可直接聯繫客服！",
      question_seven: "日活等數據能不能在手機瀏覽？",
      answer_seven:
        "超級盾有專門的APP系統供客戶使用，直接聯繫專屬客服下載即可。",
      question_eight: "添加源機有沒有上限？",
      answer_eight: "當前應用下，服務器最多255台。",
      more: "更多"
    },
    information: {
      company_dynamic: "公司動態資訊",
      company_news: "公司動態",
      trade_news: "行業新聞"
    },
    about: {
      title: "安全守衛夢想",
      company_name: "杭州超級科技有限公司",
      value_title_one: "重視我們的價值",
      value_title_two: "創造價值和成就價值",
      value_text_one: "以客戶為中心",
      value_text_two: "為客戶提供防得好、體驗佳、成本低的產品和服務",
      value_text_three: "持續追求高效運作、技術領先，不斷提升公司核心競爭力",
      mission: "使命",
      mission_text: "安全守衛夢想",
      vision: "願景",
      vision_text: "成為雲計算安全領域的領軍企業",
      value: "價值觀",
      value_text: "誠信、責任、夢想",
      contact_phone: "聯繫電話",
      url: "網址:",
      email: "郵箱:",
      address: "地址:",
      address_text: "杭州市餘杭區創鑫時代廣場3號樓B座11樓"
    },
    footer: {
      service_support: "服務支持",
      hot_product: "熱門產品",
      successful_case: "成功案例",
      shiled_sdk_App: "超級盾SDK（APP）",
      shiled_pc_App: "超級盾SDK（PC）",
      web_firewall: "Web防火牆（網站）",
      higher_defense_ip: "高防服務器（IP）",
      hot_platform: "熱門平台案例",
      live_broadcasting_platform: "直播平台案例",
      financial_company: "金融公司案例",
      help_document: "幫助文檔",
      service_agreement: "服務協議",
      privacy_policy: "隱私政策",
      telephone_hotline: "7×24小時熱線電話",
      email: "電子郵箱",
      download: "Android版下載"
    },
    product: {
      consult: "在線諮詢",
      try_out: "免費試用",
      advantage: "產品優勢",
      function: "產品功能",
      solution: "解決方案",
      case: "客戶案例",
      architecture: "部署架構",
      join_up: "接入流程",
      shiledApp: {
        banner_title: "超級盾SDK（APP）",
        banner_text:
          "專門服務於手機APP的DDoS分布式雲防禦(無限防)，同時可以100%過濾CC攻擊以及完全無視DNS攻擊。",
        advantage_one_title: "防禦效果好",
        advantage_one_text: "無限防禦DDoS、100%防CC；受攻擊時業務完全無感。",
        advantage_two_title: "防薅羊毛",
        advantage_two_text:
          "通過大數據分析，智能識別非法用戶的行為，防薅羊毛。",
        advantage_three_title: "性價比極高",
        advantage_three_text:
          "防禦成本低於傳統高防1/2；收費透明，按日活躍用戶(DAU)收費，享受無上限的防禦能力。",
        advantage_four_title: "數據更安全",
        advantage_four_text:
          "不解析用戶任何協議，不干涉用戶數據內容，盾機雙向採用AES256對業務數據進行加密。",
        function_one_title: "無視DDoS",
        function_one_text_one: "隱藏源機IP",
        function_one_text_two: "無限防禦DDoS",
        function_one_text_three: "盾機受攻擊，業務無感。",
        function_two_title: "100%防禦CC攻擊",
        function_two_text_one: "指紋驗證合法用戶",
        function_two_text_two: "100%攔截CC。",
        function_three_title: "雙盾合一組網",
        function_three_text_one: "主鏈路採用超級盾(APP版)",
        function_three_text_two: "採用800G高防IP作為備選鏈路",
        function_three_text_three: "業務動態感知,無需手動切換。",
        function_four_title: "保障用戶數據安全",
        function_four_text_one: "防劫持、木馬、入侵；",
        function_four_text_two: "採用AES256數據雙向加密",
        function_four_text_three: "防APP篡改。",
        function_five_title: "智能路由",
        function_five_text_one: "基於AI智能算法",
        function_five_text_two: "動態適配最佳路由",
        function_five_text_three: "弱網加速。",
        function_six_title: "管理可視化",
        function_six_text_one: "圖形化自定義網絡架構",
        function_six_text_two: "攻擊圖形化監控,攻擊源輕鬆追",
        function_six_text_three: "溯,消費賬單一目了然。",
        function_seven_title: "用戶級動態調速",
        function_seven_text_one: "管理顆粒度小",
        function_seven_text_two: "針對單獨用戶",
        function_seven_text_three: "TCP通訊加速/限速管理。",
        function_eight_title: "全天候防禦",
        function_eight_text_one: "流量實時經過盾機",
        function_eight_text_two: "盾機7*24小時全天候防禦。",
        double_shield: "雙盾組網",
        distributed: "分布式盾池",
        synopsis:
          "主鏈路採用超級盾(APP版)，採用800G高防IP作為備選   鏈路，業務動態感知，無需手動切換",
        solution_advantage_title: "優勢",
        solution_advantage_text_one: "性價比極高，攻擊規模越大優勢越明顯",
        solution_advantage_text_two: "7*24小時全天候防禦",
        solution_advantage_text_three: "防禦性能好，不中斷業務，不誤封IP",
        solution_advantage_text_four:
          "優化網絡資源分配，向用戶提供最優的網絡資源。對客戶應用有加速能力，用戶越多，網絡越安全",
        solution_advantage_text_five:
          "不用解析任何協議，採用報文基因技術，可100%確 保只有合法報文流入受保護的服務器",
        solution_advantage_text_six: "無視DDoS、CC攻擊，防禦無上限",
        solution_advantage_text_seven:
          "客戶級別無差異，無論大小客戶，享受同等級別的安全保障",
        case_one_title: "廣州某直播客戶",
        case_one_text: "2019年5月28號600GCC攻擊從16.39到17.27",
        case_two_title: "深圳某遊戲公司",
        case_two_text: "2019年2月15日900GDDoS攻擊從17.05到20.48"
      },
      shiledPc: {
        banner_title: "超級盾SDK（PC）",
        banner_text:
          "針對PC應用程序的防禦系統，有無源代碼均可接入，能夠抵禦一切DDoS攻擊、CC攻擊、TCP攻擊等常見攻擊手段。",
        download: "免費接入套件下載",
        advantage_one_title: "防禦效果好",
        advantage_one_text: "無限防禦DDoS、100%防CC；受攻擊時業務完全無感。",
        advantage_two_title: "接入速度快",
        advantage_two_text: "接入簡單，可接入SDK源碼，也可直接封裝登錄工具。",
        advantage_three_title: "性價比極高",
        advantage_three_text:
          "防禦成本低於傳統高防1/2；收費透明，按日活躍用戶(DAU)收費，享受無上限的防禦能力。",
        advantage_four_title: "用戶體驗佳",
        advantage_four_text:
          "直接對接數據庫中精準用戶，允許針對單獨用戶TCP/UDP通訊加速。",
        function_one_title: "分布式架構、無視DDoS",
        function_one_text_one: "隱藏源機IP",
        function_one_text_two: "無限防禦DDoS",
        function_one_text_three: "盾機受攻擊，業務無感。",
        function_two_title: "100%防禦CC攻擊",
        function_two_text_one: "指紋驗證合法用戶",
        function_two_text_two: "100%攔截CC。",
        function_three_title: "雙盾合一組網、主備兩條鏈路",
        function_three_text_one: "主鏈路採用超級盾(APP版)",
        function_three_text_two: "採用800G高防IP作為備選鏈路",
        function_three_text_three: "業務動態感知,無需手動切換。",
        function_four_title: "保障用戶數據安全",
        function_four_text_one: "防劫持、木馬、入侵；",
        function_four_text_two: "採用AES256數據雙向加密",
        function_four_text_three: "防APP篡改。",
        solution_one_title: "PC端游",
        solution_one_text:
          "PC端游很容易在開服或營銷推廣期間受到DDoS攻擊、CC攻擊，導致遊戲客戶端訪問速度緩慢，掉線率升高，甚至導致用戶流失，給PC遊戲開發商帶來不小的損失。",
        solution_two_title: "金融網站",
        solution_two_text:
          "互聯網金融行業間的競爭比較激烈，金融類客戶端也成為了DDoS、CC攻擊的主要對象，這些攻擊會導致金融客戶端無法訪問，提供正常的金融服務。",
        solution_three_title: "視頻客戶端",
        solution_three_text:
          "視頻服務為了能提供給用戶更好的使用體驗，對服務器性能及網絡質量的要求較高，當遭受DDoS攻擊時對服務器集群的壓力激增，嚴重影響用戶使用感受導致客戶流失。",
        solution_four_title: "互聯網+業務",
        solution_four_text:
          "隨着互聯網的普及，越來越多的企業搭建企業門戶客戶端，使用各種企業管理系統，經常會遭到來自競爭組織的DDoS攻擊、CC攻擊，導致客戶端無法提供企業服務，影響企業形象。"
      },
      webFirewall: {
        banner_title: "Web防火牆",
        banner_text:
          "Web防火牆對網站業務流量進行檢測，識別惡意流量請求和防禦未知威脅,確保客戶的網絡數據中心穩定運行，解決流量攻擊帶來的網站/服務器無法運行問題，DDoS防護無上限，100%防CC。",
        advantage_one_title: "無端易部署",
        advantage_one_text:
          "無需安裝下載，不改源站程序，控制台自助服務，防禦調整實時生效。",
        advantage_two_title: "多線路支持",
        advantage_two_text:
          "分布式部署多個BGP節點，覆蓋多運營商骨幹線路，網絡時延小、訪問速度快，保障穩定流暢的用戶體驗。",
        advantage_three_title: "動態防護",
        advantage_three_text:
          "根據攻擊變化，系統就近分發，智能切換防護節點，實時下發防禦規則，全網秒級生效。",
        advantage_four_title: "多協議支持",
        advantage_four_text:
          "HTTP/HTTPS/TCP/WebSocket協議，滿足網頁遊戲、網站、即時通軟件等類型的業務需求。",
        advantage_five_title: "極速部署",
        advantage_five_text:
          "5分鐘即可完成部署，實現應急防護，最大限度減少損失。",
        advantage_six_title: "靈活計費",
        advantage_six_text:
          "個性化定製各項防護策略，按需購買產品服務，彈性動態調整，節省防護成本。",
        why: "為什麼選擇Web防火牆",
        why_one_title: "分布式Web應用雲防火牆",
        why_one_text:
          "WEb防火牆是針對網站、Web遊戲、H5遊戲等領域推出的專業、高性價比的雲安全防禦產品。",
        why_two_title: "自動觸發，實時防護",
        why_two_text:
          "Web防火牆全面防禦所有類型DDoS/CC攻擊，自動觸發，實時防護，負載均衡，集群防護，加密傳輸，頁面性能優化，提升網站訪問能力，隱藏源站IP，保證系統安全和可用性。"
      },
      higherDefenseIp: {
        banner_title: "高防IP",
        banner_text:
          "高防IP是為服務器大流量DDoS攻擊的防禦產品，可通過配置高防IP，將攻擊引流到高防IP，確保源站的服務穩定。",
        advantage_one_title: "大流量清洗",
        advantage_one_text:
          "無限防禦DDoS、100%1T以上DDoS清洗能力、獨創CC防禦算法。",
        advantage_two_title: "全业务支持",
        advantage_two_text:
          "支持TCP、UDP、HTTP/HTTPS、WebSocket等應用的防禦，適用於政府、金融、遊戲、電商、社交、直播、醫療、教育等行業。",
        advantage_three_title: "性價比極高",
        advantage_three_text:
          "防禦成本低於傳統高防1/2；收費透明，按日活躍用戶(DAU)收費，享受無上限的防禦能力。",
        advantage_four_title: "接入速度快",
        advantage_four_text: "CNAME方式或將源站A記錄解析到高防IP，秒級接入。",
        function_one_title: "大流量DDoS清洗",
        function_one_text_one: "清洗中心位於運營商骨幹網核",
        function_one_text_two: "心節點機房出口1.4T；",
        function_one_text_three: "1T以上DDoS清洗能力。",
        function_two_title: "100%先進的CC防禦算法",
        function_two_text_one: "獨創CC防禦技術，防禦策略有 ",
        function_two_text_two: "100%302重定向、HTTPS證書、令",
        function_two_text_three: "牌桶算法、大數據過濾等。",
        function_three_title: "雲WAF",
        function_three_text_one: "防SQL注入，防篡改，防漏",
        function_three_text_two: "洞，防數據泄露；大數據分析",
        function_three_text_three: "技術。",
        function_four_title: "全業務支持",
        function_four_text_one: "支持TCP/UDP/HTTP/HTTPS",
        function_four_text_two: "適合遊戲、金融、電商、門",
        function_four_text_three: "戶、媒體等行業。",
        function_five_title: "源站隱藏",
        function_five_text_one: "訪問流量經由高防IP轉發到源",
        function_five_text_two: "站，不暴露源站IP，隱藏源站",
        function_five_text_three: "蹤跡。",
        function_six_title: "彈性防護",
        function_six_text_one: "支持隨時升級到更高級別的防",
        function_six_text_two: "護，升級過程服務無中斷。",
        function_seven_title: "精準攻擊流量圖",
        function_seven_text_one: "提供實時精準的流量圖，",
        function_seven_text_two: "您可及時、準確地獲得",
        function_seven_text_three: "攻擊狀態與詳情。",
        function_eight_title: "全業務支持",
        function_eight_text_one: "流量實時經過盾機",
        function_eight_text_two: "盾机7*24小時全天候防禦。",
        why: "為什麼選擇高防IP",
        why_one_title: "確保源站的服務穩定",
        why_one_text:
          "高防IP是為服務器大流量DDoS攻擊的防禦產品，用戶可通過配置高防IP，將攻擊引流到高防IP，確保源站的服務穩定。您購買高防IP服務後，Web業務把域名解析指向高防IP；非Web業務，把業務IP替換成高防IP，並配置源站IP。",
        why_two_title: "無需額外做流量牽引和回注",
        why_two_text:
          "所有公網流量都經過高防IP，高防IP將攻擊流量清洗後的正常流量回注到源站IP。配置高防IP服務後，當您遭受DDoS攻擊時，無需額外做流量牽引和回注。"
      },
      leakproof: {
        banner_title: "數據防泄漏系統",
        banner_text:
          "數據防泄漏系統對企業敏感數據泄密渠道進行嚴密的檢查和控制，加強敏感數據在創建、存儲、使用、傳輸和銷毀全生命周期的安全管理，防止泄漏行為發生、對疑似泄漏行為進行審計，為企業整體數據安全防護，提供態勢分析和智能管控支撐。",
        advantage_one_title: "全協議兼容",
        advantage_one_text:
          "系統支持對http、https、FTP、smtp、smtps、常用即時通訊軟件的網絡協議進行識別匹配並管控處理。全面杜絕敏感數據從網絡外泄。",
        advantage_two_title: "多模式快速匹配和正則後處理",
        advantage_two_text:
          "多模式匹配方法能將多個關鍵字特徵構建成狀態機，實現對文檔進行一次遍歷就能得到所有關鍵字的匹配結果。除關鍵字外，諸如身份證、銀行卡等數字特徵，也是敏感數據的主要表徵方法。",
        advantage_three_title: "數據內容智能識別引擎",
        advantage_three_text:
          "系統集成基於深度內容識別技術的數據分析引擎，可精準快速分析文檔語義，快速發現敏感信息。智能指紋不受文件格式和文檔類型的影響，只要文檔內容一致，即使文檔類型變化，文件指紋也能夠保持不變。",
        advantage_four_title: "集成自研OCR引擎",
        advantage_four_text: "集成圖像處理引擎，可兼容jpg、png等圖片數據分析。",
        advantage_five_title: "數據智能分類分級引擎",
        advantage_five_text:
          "系統具備集成自動分類及分級技術，實現數據的智能分類、分級，提高數據防泄漏的防護精度、降低誤報。"
      },
      emailLeakproof: {
        banner_title: "郵件數據防泄漏系統",
        banner_text:
          "通過對互聯網郵件協議的解析，按業務進行還原，根據制定的策略進行敏感數據匹配，一旦觸發策略，根據策略的規則處理並上報策略服務器供後續的事件分類查詢與統計，及時發現違規郵件及時處理，從而實現對所保護範圍內的郵件數據進行防護。",
        advantage_one_title: "全場景郵件監控",
        advantage_one_text:
          " 郵件客戶端、Web頁面、郵件APP客戶端等方式外發郵件，均可無縫控制，以確敏感數據郵件外發的安全。",
        advantage_two_title: "全協議監控及郵件審批",
        advantage_two_text:
          "兼容smtp/PoP3、smtps、ICMP等郵件協議。系統支持郵件審批功能，給客戶提供全程數據溯源及跟蹤機制。",
        advantage_three_title: "具備智能提速及高可用功能",
        advantage_three_text:
          "系統集成智能加速、高可用處理技術，保證郵件轉發的高效、穩定，支持負載均衡、web雙活、數據庫雙活、雙網線綁定等技術。",
        advantage_four_title: "部署方式零感知",
        advantage_four_text:
          "系統旁路部署在交換機上即可，不影響客戶單位的現網絡拓撲正常運行。",
        architecture_title: "郵件數據防泄漏系統解決方案",
        architecture_text:
          "MDLP部署在郵件系統和郵件網關之間，掃描和管控內部員工外發的電子郵件，包括標題、內容和附件，對發現含有敏感信息的郵件進行隔離，交由相關人員審批，並根據審批結果對郵件進行放行或者阻止，最終實現對通過企業郵箱泄露敏感信息的精確管控。"
      },
      defenceServer: {
        banner_title: "高防服務器",
        banner_text:
          "全BGP線路接入，帶寬、防禦能力自由選擇無防禦上線可集成智能分布式集群防禦功能。",
        advantage_one_title: "訪問速度快",
        advantage_one_text: "雙節點和BGP，骨幹網絡帶寬，有效保障訪問速度體驗。",
        advantage_two_title: "高穩定性",
        advantage_two_text:
          "採用三大運營商骨幹網絡標準化IDC，網絡採用雙鏈路和雙交換機冗餘，有效避免單點故障。",
        advantage_three_title: "高性價比",
        advantage_three_text:
          "基於集群防禦和空閒帶寬資源，能夠為用戶提供極具性價比的高防服務器，適用於中小型網站等場景。",
        advantage_four_title: "彈性擴展能力",
        advantage_four_text:
          "采用基础预付费+彈性後付費，既可以在避免帶寬浪費的前提下進行有效防護，又可以節約成本。",
        function_one_title: "穩定",
        function_one_text_one: "運營商核心機房",
        function_one_text_two: "高性能服務器。",
        function_two_title: "安全",
        function_two_text_one: "50G-2.5Tbps真實",
        function_two_text_two: "DDoS防禦能力。",
        function_three_title: "快速",
        function_three_text_one: "直連運營商骨幹網絡",
        function_three_text_two: "保證網絡通暢、高速。",
        function_four_title: "專業",
        function_four_text_one: "支持各類系統",
        function_four_text_two: "滿足多種場景使用。",
        function_five_title: "省心",
        function_five_text_one: "7*24小時服務。",
        function_six_title: "省錢",
        function_six_text_one: "超高性價比。",
        function_seven_title: "透明",
        function_seven_text_one: "提供詳細的使用報表。",
        function_eight_title: "保障",
        function_eight_text_one: "負載均衡，容災部署。",
        config_one: "配置案例一",
        config_two: "配置案例二",
        config_three: "配置案例三",
        config_title: "高防服務器配置",
        line: "線路",
        line_type: "單電信",
        physical_config: "物理配置",
        bandwidth: "帶寬",
        base_defense_capacity: "DDoS基礎防禦容量",
        cover_one: "覆蓋電信線路",
        guaranteed_one: "保底帶寬100G",
        cover_two: "覆蓋電信、聯通、移動和教育網等線路",
        guaranteed_two: "保底帶寬300G，支持彈性擴容",
        computer_room: "五星機房"
      }
    },
    solution: {
      business_challenges: "業務挑戰",
      product_advantage: "產品優勢",
      security_architecture: "安全方案架構",
      shiledApp: "超級盾SDK（APP）",
      shiledApp_text:
        "分布式雲防火牆，無限防DDoS，100%防CC攻擊，不卡不掉線，智能加速，適合各類有端的應用系統的防禦。",
      web_firewall: "Web防火牆（網站）",
      web_firewall_text:
        "分布式Web雲安全防禦產品，接入簡單、急速部署、多線路支持、動態防護。",
      more: "了解更多",
      chess: {
        banner_title: "棋牌解決方案",
        banner_text:
          "針對棋牌遊戲行業如倒賣遊戲幣，流量勒索攻擊、遊戲作弊等問題制定專屬解決方案，抵禦大流量攻擊和CC攻擊，進行APP加固等。結合多年的攻防實戰經驗，為遊戲運營打造最全面、可信賴的安全解決方案。",
        challenges_one_title: "行業競爭激烈",
        challenges_one_text:
          "對於棋牌行業來說，地域屬性極強，競爭對手較為明確，容易產生不當競爭行為，網絡攻擊成了業內絕殺武器。",
        challenges_two_title: "攻擊方式複雜多變",
        challenges_two_text:
          "通過刷註冊用戶、破解簽名算法、熱更服務器、DDoS、CC等方面的攻擊一直處於高頻狀態，攻擊常達百G以上，攻擊方式複雜多變，對於服務器端的攻擊，應用層的攻擊以及DNS攻擊是防護難題。",
        challenges_three_title: "欺詐作弊",
        challenges_three_text:
          "攻擊者利用自動化工具，通過掃庫撞庫等方式進行盜號，破解遊戲客戶端程序，改變遊戲數據，外掛程序，破壞遊戲生態平衡。",
        challenges_four_title: "卡頓和掉線",
        challenges_four_text:
          "很多棋牌遊戲平台面臨網絡危機，經常出現卡頓、掉線，甚至打不開網站等情況，嚴重影響玩家體驗度，導致平台運營艱難和玩家流失等後果。",
        advantage_one_title: "抗DDoS攻擊",
        advantage_one_text:
          "防護海量DDoS攻擊，有效抵禦所有各類基於網絡層、傳輸層及應用層的DDoS攻擊，如syn flood、UDP flood、ICMP flood等攻擊。",
        advantage_two_title: "精準防護零誤封",
        advantage_two_text:
          "全自動檢測和策略匹配，實現精準防護零誤封，使業務更安全可靠。",
        advantage_three_title: "隱藏源站IP",
        advantage_three_text:
          "隱藏服務器真實IP地址，使攻擊者無法找到受害者網絡資源，增加源站安全性。",
        advantage_four_title: "超高性價比",
        advantage_four_text:
          "高度可定製的解決方案，滿足不同階段的業務成長需求，成本比大平台更實惠。",
        architecture_chess_title: "棋牌遊戲解決方案",
        architecture_chess_text:
          "滿足移動端APP、PC端和H5棋牌等各種場景安全需求，為遊戲運營打造可信賴的安全解決方案。",
        architecture_target_title: "目標",
        architecture_target_text_one: "抵禦大流量攻擊和CC攻擊",
        architecture_target_text_two: "智能加速，遊戲不卡不掉線",
        architecture_target_text_three: "防作弊、防止薅羊毛",
        architecture_advantage_title: "優勢",
        architecture_advantage_text_one: "全業務支持",
        architecture_advantage_text_two: "無上限防禦",
        architecture_advantage_text_three: "不卡不掉線",
        architecture_advantage_text_four: "APP加固"
      },
      competitiveGame: {
        banner_title: "競技遊戲解決方案",
        banner_text:
          "針對競技遊戲行業的外掛，薅羊毛、惡意廣告、惡意拉人、色情詐騙、DDoS攻擊等黑產行為制定專屬安全解決方案，抵禦DDoS和CC攻擊，多線路近源通信，智能調配，提高網絡穩定性，遊戲不卡不掉線，提供穩定、安全的遊戲環境。",
        challenges_one_title: "高性能主機",
        challenges_one_text:
          "由於競技遊戲的實時競技屬性的特點，地圖走位，技能、裝備、人物屬性頻繁發生變化，需高性能服務器端進行大量運算，因此遊戲運行主機性能和穩定性極為重要。",
        challenges_two_title: "高質量網絡",
        challenges_two_text:
          "由於競技遊戲的玩法為即時戰鬥，客戶端與服務器端頻繁產生交互，對網絡延時和穩定性要求非常高。",
        challenges_three_title: "安全問題複雜多變",
        challenges_three_text:
          "遊戲在上線後，網絡攻擊層出不窮，包括Ddos、cc和應用層等方面的攻擊等一直處於高頻狀態。遊戲廠商往往缺乏應對手段，影響遊戲正常運行，嚴重者將會造成遊戲中斷和玩家流失。",
        challenges_four_title: "故障快速遷移能力",
        challenges_four_text:
          "競技類遊戲通常單點服務，單機可靠性以及在單機故障後快速恢復的能力至關重要。",
        advantage_one_title: "高性能雲服務器",
        advantage_one_text_one: "提供高性能雲服務器ECS，雲服務器",
        advantage_one_text_two: "計算資源獨享，確保遊戲服務",
        advantage_one_text_three: "穩定地運營。",
        advantage_two_title: "無上限防禦",
        advantage_two_text_one: "無上限防禦DDoS，超級盾(APP版)100%",
        advantage_two_text_two: "防CC，一站式解決遊戲業主頻繁被",
        advantage_two_text_three: "DDoS/CC攻擊的煩惱。",
        advantage_three_title: "不卡不掉線",
        advantage_three_text_one: "被攻擊時完全無感，遊戲不卡不掉線",
        advantage_three_text_two: "分布式架構，智能路由、弱網加速，充",
        advantage_three_text_three: "分保障用戶遊戲體驗。",
        advantage_four_title: "超高性價比",
        advantage_four_text_one: "高度可定製的解決方案，滿足不同",
        advantage_four_text_two: "階段的業務成長需求，成本比大平台",
        advantage_four_text_three: "更實惠。",
        architecture_competitive_title: "競技遊戲解決方案",
        architecture_competitive_text:
          "抵禦DDoS和CC攻擊，多線路近源通信，智能調配，提高網絡穩定性，不卡不掉線，提供穩定、安全的遊戲環境。",
        architecture_target_title: "目標",
        architecture_target_text_one: "抵禦DDoS和CC攻擊",
        architecture_target_text_two: "智能加速，遊戲不卡不掉線",
        architecture_target_text_three: "防作弊、防止薅羊毛",
        architecture_advantage_title: "優勢",
        architecture_advantage_text_one: "無上限防禦",
        architecture_advantage_text_two: "高性能雲服務器/CC攻擊",
        architecture_advantage_text_three: "不卡不掉線",
        architecture_advantage_text_four: "超高性價比"
      },
      web_service: {
        banner_title: "web服務安全解決方案",
        banner_text:
          "無視一切DDoS/CC攻擊，網站惡意流量清洗識別，將正常、安全的流量回源到服務器。避免網站服務器被惡意入侵，確保您的網絡數據中心穩定運行，解決因流量攻擊導致的服務器性能異常問題。",
        web_security_challenges: "web安全挑戰",
        challenges_one_title: "黑客入侵",
        challenges_one_text:
          "撞庫拖庫進行信息盜取，篡改網頁內容，通過後門木馬將主機變成肉雞實施攻擊，加密數據庫進行勒索等。",
        challenges_two_title: "業務欺詐",
        challenges_two_text:
          "羊毛黨的垃圾註冊，刷粉、刷票、刷積分等欺詐行為造成的業務損失。",
        challenges_three_title: "惡意內容",
        challenges_three_text:
          "涉黃、涉政、涉恐文字、圖片或音視頻導致的監管風險，影響品牌形象及業務運轉。",
        advantage_one_title: "全面防護常見Web攻擊威脅",
        advantage_one_text:
          "為HTTP／HTTPS業務提供SQL注入、XSS跨站、Webshell上傳、非授權訪問等多種Web服務攻擊防護功能，保障網站的安全與可用性。",
        advantage_two_title: "無上限DDoS/CC攻擊防護",
        advantage_two_text:
          "智能識別CC攻擊，迅速識別CC攻擊並進行攔截，在大規模CC攻擊時可以避免源站資源耗盡，保證用戶網站的正常訪問。",
        advantage_three_title: "低誤殺秒解封",
        advantage_three_text:
          "對訪問頻率過快的IP不再直接粗暴的封禁，而是綜合URL請求、響應碼等分布特徵判斷異常行為，全自動檢測和策略匹配，實現精準防護，低誤殺秒解封，使業務更安全可靠。",
        advantage_four_title: "隱藏源站IP",
        advantage_four_text:
          "隱藏服務器真實IP地址，使攻擊者無法找到受害者網絡資源，增加源站安全性。",
        architecture_web_service_title: "Web服務安全解決方案",
        architecture_competitive_text:
          "無視一切DDoS/CC攻擊，網站惡意流量清洗識別，將正常、安全的流量回源到服務器。",
        architecture_target_title: "目標",
        architecture_target_text_one: "避免網站服務器被惡意入侵",
        architecture_target_text_two: "網絡數據中心穩定運行",
        architecture_target_text_three:
          "解決因流量攻擊導致的服務器性能異常問題",
        architecture_advantage_title: "優勢",
        architecture_advantage_text_one: "全面防護",
        architecture_advantage_text_two: "隱藏源站IP",
        architecture_advantage_text_three: "低誤殺秒解封",
        architecture_advantage_text_four: "無上限CC攻擊防護"
      },
      financial: {
        banner_title: "金融解決方案",
        banner_text:
          "超級科技從網絡、業務、數據多個維度為金融客戶在應用、業務、可用等安全領域提供量身定製的個性化安全解決方案，通過立體防護機制抵禦多種惡意攻擊，海量計算、彈性部署解決業務的海量並發，結合資深安全專家服務，助力金融行業做到全面合規、持續發展，保障業務和數據安全。",
        financial_challenges: "金融行業面臨的挑戰",
        challenges_one_title: "黑客入侵",
        challenges_one_text:
          "DDoS攻擊已經成為當前金融領域極其常見的安全威脅，被攻擊、被「肉雞」，以及基於DDoS的勒索事件也是逐漸趨於頻繁。",
        challenges_two_title: "安全投入成本高",
        challenges_two_text:
          "金融行業機構整合雲端面臨技術投入大，成本高，不靈活，運維難度大，交付周期長等問題。",
        challenges_three_title: "數據安全要求高",
        challenges_three_text:
          "金融領域對於客戶的隱私保護、企業的數據安全、產品安全等尤其重要，一旦泄露，不僅遭受口碑、經濟上的損失，也面臨着法律風險。",
        challenges_four_title: "業務欺詐",
        challenges_four_text:
          "羊毛黨的垃圾註冊，惡意掃號撞庫，刷粉、刷票、刷積分等各種欺詐行為造成的業務損失。",

        advantage_one_title: "全面防護常見Web攻擊威脅",
        advantage_one_text:
          "為HTTP／HTTPS業務提供SQL注入、XSS跨站、Webshell上傳、非授權訪問等多種Web服務攻擊防護功能，保障網站的安全與可用性。",
        advantage_two_title: "無上限DDoS/CC攻擊防護",
        advantage_two_text:
          "提供T級DDoS流量清洗防護以及千萬級異常請求過濾的CC防護，有效解決黑客對金融服務器發起的流量攻擊，保證業務正常進行。",
        advantage_three_title: "可視化數據分析報告",
        advantage_three_text:
          "提供詳實的可視化安全數據分析報告，客戶可根據需求查看歷史安全記錄，並可選擇固定周期，自動生成詳細安全報表功能。",
        advantage_four_title: "專家1V1支持",
        advantage_four_text:
          "提供1V1專屬安全專家服務，快速響應客戶需求，並制定專有的安全解決方案。",

        architecture_financial_title: "金融解决方案",
        architecture_competitive_text:
          "助力金融行業做到全面合規、持續發展，保障業務和數據安全。",
        architecture_target_title: "目標",
        architecture_target_text_one: "保障網站的安全與可用性",
        architecture_target_text_two: "保證業務正常進行",
        architecture_target_text_three: "提供詳實的可視化安全數據分析報告",
        architecture_advantage_title: "優勢",
        architecture_advantage_text_one: "全面防護",
        architecture_advantage_text_two: "無上限DDoS/CC攻擊",
        architecture_advantage_text_three: "可視化數據分析報告",
        architecture_advantage_text_four: "專家1V1支持"
      },
      geme: {
        banner_title: "遊戲解決方案",
        banner_text:
          "滿足移動端APP、PC端等各種場景安全需求。抵禦大流量攻擊和CC攻擊；智能加速，遊戲不卡不掉線。對APP進行加固，防倒賣遊戲幣、防作弊、防止薅羊毛。海量攻防實戰積累，為遊戲運營打造可信賴的安全解決方案。",
        advantage_one_title: "高性能雲服務器",
        advantage_one_text_one: "提供高性能雲服務器ECS，雲服務器",
        advantage_one_text_two: "計算資源獨享，確保遊戲服務",
        advantage_one_text_three: "穩定地運營。",
        advantage_two_title: "無上限防禦",
        advantage_two_text_one: "無上限防禦DDoS，超級盾(APP版)100%",
        advantage_two_text_two: "防CC，一站式解決遊戲業主頻繁被",
        advantage_two_text_three: "DDoS/CC攻擊的煩惱。",
        advantage_three_title: "不卡不掉線",
        advantage_three_text_one: "被攻擊時完全無感，遊戲不卡不掉線",
        advantage_three_text_two: "分布式架構，智能路由、弱網加速，",
        advantage_three_text_three: "充分保障用戶遊戲體驗。",
        advantage_four_title: "超高性價比",
        advantage_four_text_one: "高度可定製的解決方案，滿足不同",
        advantage_four_text_two: "階段的業務成長需求，成本比大平台",
        advantage_four_text_three: "更實惠。"
      },
      EC: {
        banner_title: "電商解決方案",
        banner_text:
          "針對電商行業高並發，垃圾流量，惡意刷單，突發大規模惡意攻擊，漏洞攻擊制定專屬解決方案，助力電商客戶應對各種業務問題，保障電商交易安全進行，電商活動順利完成！",
        advantage_one_title: "防禦性能好",
        advantage_one_text_one: "高效防DDoS攻擊，CC攻擊，垃圾",
        advantage_one_text_two: "流量，輕鬆應對各類攻擊，充分保障",
        advantage_one_text_three: "促銷等活動安全。",
        advantage_two_title: "流量智能調度",
        advantage_two_text_one: "分布式架構，智能DNS，智能緩",
        advantage_two_text_two: "存，輕鬆應對活動及其它緊急情況，",
        advantage_two_text_three: "有效降低服務器壓力。",
        advantage_three_title: "數據更安全",
        advantage_three_text_one: "雲WAF功能，防漏洞，防篡改，防",
        advantage_three_text_two: "SQL注入，數據指紋驗證。",
        advantage_three_text_three: "充分保障用戶遊戲體驗。",
        advantage_four_title: "服務有保障",
        advantage_four_text_one: "24小時全天候運維，提供專業的",
        advantage_four_text_two: "維護服務，對電商網站的促銷活動提",
        advantage_four_text_three: "供專項保障，對安全防護狀況進行監控和預警。",
        architecture_financial_title: "電商解決方案",
        architecture_competitive_text:
          "針對電商行業高並發，垃圾流量，惡意刷單，突發大規模惡意攻擊，漏洞攻擊制定專屬解決方案。",
        architecture_target_title: "目標",
        architecture_target_text_one: "助力電商客戶應對各種業務問題",
        architecture_target_text_two: "保障電商交易安全進行",
        architecture_target_text_three: "電商活動順利完成",
        architecture_advantage_title: "優勢",
        architecture_advantage_text_one: "防禦性能好",
        architecture_advantage_text_two: "流量智能調度/CC攻擊",
        architecture_advantage_text_three: "數據更安全",
        architecture_advantage_text_four: "服務有保障"
      },
      education: {
        banner_title: "教育行業安全解決方案",
        banner_text:
          "針對教育信息化發展所面臨的網絡漏洞和數據泄露風險，為教育行業提供移動APP加固、Web防火牆，防止黑客的惡意篡改、代碼植入，抵禦大流量攻擊和CC攻擊，為教育類APP、網站提供合規、安全的解決方案，助力教育信息化的安全發展。",
        education_challenges: "教育行業面臨的挑戰",

        challenges_one_title: "信息泄露嚴重",
        challenges_one_text:
          "通過代碼注入、篡改等非法手段竊取用戶信息，導致校園貸、電信詐騙等引發的惡性事件時有發生，被推銷電話和垃圾短信頻繁騷擾，苦不堪言。",
        challenges_two_title: "核心資源泄漏",
        challenges_two_text:
          "付費教學資源被盜用，文件包被劫持，造成教育企業經濟損失，影響教育企業發展。",
        challenges_three_title: "受攻擊風險高",
        challenges_three_text:
          "DDoS攻擊已經成為教育行業極其常見的安全威脅，被攻擊導致網站無法打開，學員無法完成學習，損害廣大師生利益。",
        challenges_four_title: "惡意插入/篡改",
        challenges_four_text:
          "對移動APP、Web站點植入惡意廣告、或篡改廣告ID，非法截取企業收益。",

        advantage_one_title: "全方位的APP加固保護",
        advantage_one_text:
          "基於全方位的安全加固保護，防止移動APP被劫持、木馬、入侵，採用AES256數據雙向加密，防止移動APP被篡改。",
        advantage_two_title: "無上限DDoS/CC攻擊防護",
        advantage_two_text:
          "提供T級DDoS流量清洗防護以及千萬級異常請求過濾的CC防護，有效解決黑客對金融服務器發起的流量攻擊，保證業務正常進行。",
        advantage_three_title: "全面防護常見Web攻擊威脅",
        advantage_three_text:
          "為HTTP／HTTPS業務提供SQL注入、XSS跨站、Webshell上傳、非授權訪問等多種Web服務攻擊防護功能，保障網站的安全與可用性。",
        advantage_four_title: "專家1V1支持",
        advantage_four_text:
          "提供1V1專屬安全專家服務，快速響應客戶需求，並制定專有的安全解決方案。",

        architecture_education_title: "教育行業安全解決方案",
        architecture_competitive_text:
          "提供移動APP加固、Web防火牆，防止黑客的惡意篡改、代碼植入，抵禦大流量攻擊和CC攻擊，為教育類APP、網站提供合規、安全的解決方案。",
        architecture_target_title: "目標",
        architecture_target_text_one: "確保服務器穩定運行",
        architecture_target_text_two: "避免用戶信息的泄露",
        architecture_target_text_three: "保障付費資源不被劫持",
        architecture_advantage_title: "優勢",
        architecture_advantage_text_one: "全方位的APP加固保護",
        architecture_advantage_text_two: "全面防護Web攻擊威脅",
        architecture_advantage_text_three: "無上限DDoS/CC攻擊防護",
        architecture_advantage_text_four: "專家1V1支持"
      }
    },
    header: {
      home: "首頁",
      product: "產品",
      solution: "解決方案",
      help: "服務支持",
      information: "超級資訊",
      about: "關於我們",
      product_list: {
        network_security: "網絡安全",
        data_security: "數據安全",
        super_cloud: "超級雲",
        data_center: "數據中心",
        network_security_list: {
          shiled_app: "超級盾SDK（APP）",
          shiled_app_text: "針對手機APP的DDoS、CC、DNS等攻擊的無限防禦產品。",
          shiled_pc: "超級盾SDK（PC）",
          shiled_pc_text:
            "針對PC的DDoS、CC、DNS等攻擊的無限防禦產品，支持免代碼接入。",
          firewall_web: "Web防火牆（網站）",
          firewall_web_text: "優質節點、分布式、智能調度、可防禦ddos與cc攻擊。",
          defence_ip: "高防IP",
          defence_ip_text:
            "幫助您自動智能防護DDoS攻擊，減少業務損失，降低未知風險。"
        },
        data_security_list: {
          leakproof: "數據防泄漏系統",
          shiled_app_text: "針對手機APP的DDoS、CC、DNS等攻擊的無限防禦產品。",
          emailLeakproof: "郵件數據防泄漏系統",
          shiled_pc_text: "針對手機APP的DDoS、CC、DNS等攻擊的無限防禦產品。"
        },
        super_cloud: {
          defence_server: "高防服務器",
          defence_server_text: "即時部署可伸縮、可防禦ddos、CC攻擊的雲計算。"
        },
        data_center: {
          defence_server: "高防服務器",
          defence_server_text: "即時部署可伸縮、可防禦ddos、CC攻擊的雲計算。"
        }
      },
      solution_list: {
        scenario_solution: "場景解決方案",
        industry_solution: "行業解決方案",
        scenario_list: {
          chess: "棋牌遊戲",
          chess_text:
            "抵禦大流量攻擊、網絡加速，不卡不掉線、APP加固，防作弊、防薅羊毛等。",
          competitive_game: "競技遊戲",
          competitive_game_text:
            "智能掉配、提高網絡穩定性、降低延遲、多線路近源通信。",
          web_serve: "Web服務",
          web_serve_textt: "sql注入、web滲透、拒絕服務攻擊、分布式緩存加速等。"
        },
        industry_list: {
          financial: "金融",
          financial_text: "極高的網絡穩定性、極低網絡延遲，守護數據安全",
          game: "遊戲",
          game_text:
            "防禦各種形式上的網絡攻擊、避免對手惡意競爭、高穩定、不卡不掉線。",
          EC: "電商",
          EC_text:
            "有效防禦突發大規模惡意工具，漏洞攻擊，避免垃圾流量，防止惡意刷單。",
          education: "教育行業",
          education_text:
            "全方位對移動APP進行加固，防止被劫持、木馬、入侵、篡改，提供SQL注入、XSS跨站、Webshell上傳、非授權訪問等多種Web服務攻擊防護功能。"
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/lang/tw-CH.js